export default function displayUrl(input: string): string {
  const httpRemoved = input.replace(/^https?:\/\//i, "")
  const trailingSlashRemoved = httpRemoved.replace(/\/$/i, "")
  return trailingSlashRemoved
}
